<template>

    <div class="trustmarks">
        <div class="content lh-tight">
            <p>Your payment details are submitted securely with Stripe, one of the world's leading payment processors.</p>
        </div>
        
        <ul class="listing accepted-cards">
            <li><svg-icon id="stripe"></svg-icon></li>
            <li><svg-icon id="amex"></svg-icon></li>
            <li><svg-icon id="mastercard"></svg-icon></li>
            <li><svg-icon id="visa"></svg-icon></li>
        </ul>
    </div>
    
</template>

<script>
export default {
    data() {
        return {
        };
    },
};
</script>